export const capitalizeString = (word:string) =>{

    
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
